import '../../common_screen/my_result_contest_list/index.css';
import FlatList from 'flatlist-react';
import {
  FlatListWrapper,
  HeaderWithTimer,
  PaginationIndicator,
  RouteWrapper
} from '../../../component';
import { YNContestResultCard } from '../../component';
import PullToRefresh from 'react-simple-pull-to-refresh';
import React from 'react';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyContestListMWeb = ({
  gameType,
  matchItem,
  onPressBack,
  onPressCard,
  verified,
  challenges,
  matchTeamScore,
  onRefresh,
  tabType
}: any) => {
  const renderResultItem = (item: any) => (
    <YNContestResultCard
      contest={item}
      onPressCard={() => onPressCard(item, true)}
      matchVerifiedStatus={verified}
      matchTeamScore={matchTeamScore}
    />
  );

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          tabType={tabType}
          onCalledDeadline={() => {}}
          gameType={gameType}
        />

        <PullToRefresh className="my-contest-list-flat-list-wrapper" onRefresh={onRefresh}>
          <FlatListWrapper>
            <FlatList
              list={challenges}
              renderItem={renderResultItem}
              paginationLoadingIndicator={<PaginationIndicator />}
            />
          </FlatListWrapper>
        </PullToRefresh>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default React.memo(MyContestListMWeb);
